import { createFileRoute } from '@tanstack/react-router';
import { PurchaseResult } from '@/features/pda/result/purchase-result';

function ResultRoute() {
  const { reference } = Route.useParams();
  return <PurchaseResult reference={reference} />;
}

export const Route = createFileRoute('/_app/sale/result/$reference')({
  component: ResultRoute,
});
